import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
// import { makeStyles } from "@mui/styles";
import FormHelperText from "@mui/material/FormHelperText";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";

//Custom style for error message.
// const helperTextStyles = makeStyles((theme) => ({
//   root: {
//     margin: 4,
//     color: "#D8000C",
//   },
//   // error: {
//   //   "&.MuiFormHelperText-root.Mui-error": {
//   //     color: "",
//   //   },
//   // },
// }));

const CustomizedInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    borderRadius: 22,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontsize: 12,
    width: 190,
    padding: "8px 10px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),

    "&:focus": {
      borderRadius: 22,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}));

//Select Core Component
const SelectBox = (props) => {
  const {
    name,
    id,
    placeholder,
    options,
    className,
    onChange,
    required,
    errorMessage,
    value,
    disabled,
  } = props;
  // const helperTestClasses = helperTextStyles();
  return (
    <>
      <Select
        disabled={disabled}
        name={name}
        required={required}
        onChange={onChange}
        className={className}
        label={placeholder}
        value={value}
        id={id}
        input={<CustomizedInput />}
      >
        {options.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText
        // classes={{
        //   root: helperTestClasses.root,
        //   error: helperTestClasses.error,
        // }}
      >
        {errorMessage}
      </FormHelperText>
    </>
  );
};

export default SelectBox;
